export const API = '/api';

// Coût en crédits par défaut pour la génération PDF BATICO
export const DEFAULT_CREDIT_COST_PDF = 2;
